export const AnnotationIcon = ({ color = '#363BC4', size = 11 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size * 12) / 11}
    fill="none"
    viewBox="0 0 20 21"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 8.5V5m0 7h.01M7.9 17.2l1.46 1.947c.217.29.326.434.459.486a.5.5 0 0 0 .362 0c.133-.052.242-.197.459-.486L12.1 17.2c.293-.39.44-.586.619-.735a2 2 0 0 1 .822-.412c.226-.053.47-.053.959-.053 1.398 0 2.097 0 2.648-.228a3 3 0 0 0 1.624-1.624C19 13.597 19 12.898 19 11.5V5.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 1 15.88 1 14.2 1H5.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C1 3.28 1 4.12 1 5.8v5.7c0 1.398 0 2.097.228 2.648a3 3 0 0 0 1.624 1.624C3.403 16 4.102 16 5.5 16c.489 0 .733 0 .96.053a2 2 0 0 1 .822.412c.178.149.325.344.618.735"
    />
  </svg>
);
